import { render, staticRenderFns } from "./SelectType.vue?vue&type=template&id=3573e1f7"
import script from "./SelectType.vue?vue&type=script&lang=js"
export * from "./SelectType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3573e1f7')) {
      api.createRecord('3573e1f7', component.options)
    } else {
      api.reload('3573e1f7', component.options)
    }
    module.hot.accept("./SelectType.vue?vue&type=template&id=3573e1f7", function () {
      api.rerender('3573e1f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "libs/components/FormBuilder/ComponentsByTypes/SelectType.vue"
export default component.exports